import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../api/axios";
import Rtecourse from "../Rte/Rtecourse";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Snackbar,
  Alert,
  Box,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import Master from "../../utils/Master";
import { useContext } from "react";

const API_URL = "courses";
const GROUP_API_URL = "group";

const CourseDetails = () => {
  const {setaboutcourse} = useContext(Master)
  const [courses, setCourses] = useState([]);
  const [iconGroups, setIconGroups] = useState([]);
  const [editedData, setEditedData] = useState({
    coursename: "",
    icongroup: {},
    about: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    action: "",
    targetId: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [aboutPopupOpen, setAboutPopupOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentAboutCourseId, setCurrentAboutCourseId] = useState(null);

  // Fetch data
  const fetchCourses = async () => {
    try {
      const res = await axios.get("courses");
      setCourses(res.data.result || []);
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  const fetchIconGroups = async () => {
    try {
      const res = await axios.get(GROUP_API_URL);
      setIconGroups(res.data || []);
    } catch (err) {
      console.error("Error fetching icon groups:", err);
    }
  };

  useEffect(() => {
    fetchCourses();
    fetchIconGroups();
  }, []);

  const handleCloseSnackbar = () =>
    setSnackbar((prev) => ({ ...prev, open: false }));

  // --- Dialog handlers ---
  const handleOpenDialog = (course = null) => {
    if (course) {
      // Edit mode
      setEditedData({
        coursename: course.coursename,
        icongroup: iconGroups.find((g) => g.id === course.icongroupid) || {},
        about: course.about,
      });
      setIsEditMode(true);
    } else {
      // Add mode
      setEditedData({ coursename: "", icongroup: {}, about: "" });
      setIsEditMode(false);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditedData({ coursename: "", icongroup: {}, about: "" });
  };

  // --- About dialog (RTE) ---
  const handleOpenAbout = () => {
    setAboutPopupOpen(true);
  };
  const handleCloseAbout = () => setAboutPopupOpen(false);
  const handleSaveAbout = (htmlValue) =>
    setEditedData({ ...editedData, about: htmlValue });

  // --- Save / Delete Confirmation ---
  const handleConfirm = (action, targetId = null) => {
    setConfirmDialog({ open: true, action, targetId });
  };

  const handleCloseConfirm = () =>
    setConfirmDialog({ open: false, action: "", targetId: null });

  const handleConfirmAction = async () => {
    if (confirmDialog.action === "delete") {
      await handleDelete(confirmDialog.targetId);
    } else if (confirmDialog.action === "save") {
      await handleSave();
    }
    handleCloseConfirm();
  };

  // --- CRUD operations ---
  const handleSave = async () => {
    try {
      const payload = {
        coursename: editedData.coursename,
        icongroupid: editedData.icongroup.id,
        icongroup_name: editedData.icongroup.name,
        iconlist: editedData.icongroup.iconlist,
        about: editedData.about,
      };

      if (isEditMode) {
        await axios.put(
          `${API_URL}/${courses.find((c) => c.id === editedData.id)?.id}`,
          payload
        );
      } else {
        await axios.post(API_URL, payload);
      }

      fetchCourses();
      handleCloseDialog();
    } catch (err) {
      console.error("Error saving course:", err);
    }
  };

  const handleAboutChange = React.useCallback(
    (htmlValue) => {
          // Update context
    setaboutcourse(htmlValue);
      setEditedData((prev) => ({ ...prev, about: htmlValue }));
    },
    [] // memoize to avoid new function on every render
  );

  const handleDelete = async (id) => {
    try {
      const ok = await axios.delete(`${API_URL}/${id}`);
      if (ok) {
        setSnackbar({
          open: true,
          message: "Course Deleted successfully!",
          severity: "success",
        });
      }
      fetchCourses();
    } catch (err) {
      console.error("Error deleting course:", err);
      setSnackbar({
        open: true,
        message: "Failed to delete Course",
        severity: "error",
      });
    }
  };

  const handleRowClick = (course = null) => {
    if (course) {
      // Edit mode
      setEditedData({
        id: course.id,
        coursename: course.coursename,
        icongroup: iconGroups.find((g) => g.id === course.icongroupid) || {},
        about: course.about,
      });
      setIsEditMode(true);
    } else {
      // Add mode
      setEditedData({ coursename: "", icongroup: {}, about: "" });
      setIsEditMode(false);
    }
    setOpenDialog(true);
  };

  // console.log("editedData❌❌❌❌❌", editedData);

  // --- Render ---
  return (
    <Paper sx={{ padding: 3, margin: 0 }}>
      <Box display="flex" alignItems="center" justifyContent="end" mb={2}>
        <Button variant="contained" onClick={() => handleOpenDialog()}>
          Add New Course
        </Button>
      </Box>

      <TableContainer>
        <Table
          sx={{
            "& .MuiTableRow-root": {
              height: "35px !important", // force override default MUI height
            },
            "& .MuiTableCell-root": {
              paddingTop: "4px !important",
              paddingBottom: "4px !important",
              fontSize: "0.9rem",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Sl No</b>
              </TableCell>
              <TableCell>
                <b>Course Name</b>
              </TableCell>
              <TableCell>
                <b>Icon Group</b>
              </TableCell>
              {/* <TableCell><b>About</b></TableCell> */}
              <TableCell>
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courses.map((course, index) => (
              <TableRow key={course.id} onClick={() => handleRowClick(course)}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{course.coursename}</TableCell>
                <TableCell>{course.name}</TableCell>
                {/* <TableCell>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: course.about?.slice(0, 100) + (course.about?.length > 50 ? "..." : "")
                    }}
                  />
                  {course.about?.slice(0, 50) + (course.about?.length > 50 ? "..." : "")}
                </TableCell> */}
                <TableCell>
                  {/* <IconButton
                    color="primary"
                    onClick={() => handleOpenDialog(course)}
                  >
                    <Edit />
                  </IconButton> */}
                  <IconButton
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleConfirm("delete", course.id);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* --- Add/Edit Dialog --- */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
        keepMounted
      >
        <DialogTitle>
          {isEditMode ? "Edit Course" : "Add New Course"}
        </DialogTitle>

        <DialogContent>
          {/* --- Course Name --- */}
          <TextField
            fullWidth
            margin="normal"
            label="Course Name"
            value={editedData.coursename}
            onChange={(e) =>
              setEditedData({ ...editedData, coursename: e.target.value })
            }
          />

          {/* --- Icon Group Select --- */}
          <Select
            fullWidth
            margin="normal"
            value={editedData.icongroup?.id || ""}
            onChange={(e) => {
              const group = iconGroups.find((g) => g.id === e.target.value);
              setEditedData({ ...editedData, icongroup: group });
            }}
            displayEmpty
          >
            <MenuItem value="">Select Icon Group</MenuItem>
            {iconGroups.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
          </Select>

          {/* --- About (Rich Text Editor) --- */}
          <div style={{ marginTop: "16px" }}>
            <h4>About Certificate</h4>
            <Rtecourse
              onChange={handleAboutChange}
              initialValue={editedData.about}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button
            onClick={() => handleConfirm("save")}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* --- Confirmation Dialog --- */}
      <Dialog open={confirmDialog.open} onClose={handleCloseConfirm}>
        <DialogTitle>
          Confirm {confirmDialog.action === "delete" ? "Delete" : "Save"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {confirmDialog.action === "delete"
              ? "Are you sure you want to delete this course?"
              : "Do you want to save the changes?"}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm}>Cancel</Button>
          <Button
            color={confirmDialog.action === "delete" ? "error" : "primary"}
            variant="contained"
            onClick={handleConfirmAction}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default CourseDetails;
